import './statistics.scss';

export default () => {

};
